/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const VM_TYPES = "VMs";
